import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import ExtraDescription from "src/Component/ExtraDescription";

const PageId = 8;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const backButtonConfig = {
    label: "Back",
    type: "back",
    startIcon: { icon: "arrow-right", color: "#fff" },
    onClick: () => setCurrentPage(BackPageId),
    style: { gap: "var(--width-16)" },
  };

  const nextButtonConfig = {
    label: "Next",
    type: "next",
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NextPageId),
    style: { gap: "var(--width-16)" },
  };

  return {
    bgVideo: {
      video: `${Config.BASE_URL}/videos/bg_${PageId}.mp4`,
      poster: `${Config.BASE_URL}/images/BG/bg_${PageId}.jpg`,
    },
    title: "Business Insights Dashboard",
    description: `Harness real-time data to make smarter\nbusiness decisions and maximize operational\nefficiency.`,
    leftAfterDescription: (
      <ExtraDescription
        text={`Key Features:<ul>\n<li>Real-Time Analytics: Track user satisfaction,\nsubscription trends, and cost savings in a\nsingle dashboard.</li>\n<li>Predictive Insights: Leverage AI-driven\nautomation to forecast business performance\nand identify opportunities.</li>\n<li>Operational Efficiency: Reduce churn,\noptimize revenue, and enhance user\nengagement with actionable insights.</li></ul>`}
      />
    ),

    back: backButtonConfig,
    next: nextButtonConfig,
  };
};

export default DATA;
